import { Grid } from "@mui/material";
import { MprcButton } from "components";
import { EnrollmentViewDto, MeetingType, TrainingMeetingItemDto } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getEnrollmentCertificate } from "../../../Shared/EnrollmentActions";
import { EnrollmentCloseButton } from "../../../Shared/EnrollmentCloseButton";
import { MeetingRecordingViewer } from "./MeetingRecordingViewer";

interface IProps {
    meeting: TrainingMeetingItemDto;
    classroomId?: string | null;
    enrollment?: EnrollmentViewDto;
    onReload: () => void;
}

export const ActionButtonMeeting = (props: IProps) => {

    const { meeting, classroomId, enrollment, onReload } = props;

    const { t } = useTranslation("lms");
    const api = useCoreApi();

    const [openRecording, setOpenRecording] = useState<boolean>(false);

    const isRecording = meeting.finished && meeting.recordingFile != null;
    const isShort = enrollment && (enrollment.canFinish || enrollment.hasCertificate) && isRecording;

    ///
    const openLinkOnline = async () => {

        if (!meeting.meetingOnlineLink || !meeting.startDate) {
            enqueueSnackbar("Student.EnrollmentView.Content.Meeting.UnavailableText", { variant: "warning" });
            return;
        }

        let url = meeting.meetingOnlineLink;

        if (!meeting.isInstructor) {

            var now = moment(new Date());
            var startDate = moment(meeting.startDate);

            if (startDate.diff(now, "minutes") >= 30) {
                enqueueSnackbar(t("Student.EnrollmentView.Content.Meeting.AvailableOnText", { date: Formaters.performaDate(meeting.startDate) }), { variant: "warning" });
                return;
            }
        }
        else {
            if (meeting.meetingOnlineLinkExpired && classroomId) {
                try {
                    const response = await api.v1.trainingManagement.updateZoomInstructorLinkCommand({ classroomId, componentId: meeting.componentId });
                    if (response.data != null) url = response.data;
                    window.open(response.data, "");
                }
                catch {
                    enqueueSnackbar(t("Student.EnrollmentView.Content.Meeting.CannotUpdateInstructorLink"), { variant: "error" });
                }
            }
        }

        window.open(url, "");
    };

    /////////////////////////////////////////////////////////////////////////////////////

    ///
    const CertificateButton = () => {
        return (
            <MprcButton
                sx={{ minWidth: isShort ? 100 : 220 }}
                text={t(isShort ? "Student.EnrollmentView.CertificateShortButtonText" : "Student.EnrollmentView.CertificateButtonText")}
                title={t(isShort ? "Student.EnrollmentView.CertificateShortButtonText" : "Student.EnrollmentView.CertificateButtonText")}
                color={"success"}
                variant="contained"
                onClick={() => getEnrollmentCertificate(enrollment!.certificateId!)}
            />
        );
    };

    ///
    const RecordingButton = () => {
        return (
            <>
                <MprcButton
                    sx={{ minWidth: isShort ? 100 : 220 }}
                    text={t(isShort ? "Student.EnrollmentView.Content.Meeting.RecordingShortButtonText" : "Student.EnrollmentView.Content.Meeting.RecordingButtonText")}
                    title={t(isShort ? "Student.EnrollmentView.Content.Meeting.RecordingShortButtonTitle" : "Student.EnrollmentView.Content.Meeting.RecordingButtonTitle")}
                    color="primary"
                    variant="contained"
                    onClick={() => setOpenRecording(true)}
                />
                {meeting.recordingFile && openRecording &&
                    <MeetingRecordingViewer
                        enrollmentId={enrollment!.enrollmentId}
                        meeting={meeting}
                        onClose={() => { setOpenRecording(false); onReload(); }}
                    />
                }
            </>
        );
    };

    ///
    const JoinButton = () => {
        return (
            <MprcButton
                sx={{ width: 220 }}
                text={t("Student.EnrollmentView.Content.Meeting.JoinButtonText")}
                title={t("Student.EnrollmentView.Content.Meeting.JoinButtonTitle")}
                color="primary"
                variant="contained"
                onClick={openLinkOnline}
                disabled={enrollment?.isPreview === true || enrollment?.readOnly === true}
            />
        );
    };

    /////////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    /////////////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {
                isShort
                    ?
                    <Grid container justifyContent="space-around" sx={{ width: 220 }}>
                        <Grid>
                            {
                                enrollment?.hasCertificate
                                    ? CertificateButton()
                                    : enrollment?.canFinish
                                        ? <EnrollmentCloseButton />
                                        : null
                            }
                        </Grid>
                        {isRecording &&
                            <Grid>
                                {RecordingButton()}
                            </Grid>
                        }
                    </Grid>
                    :
                    <>
                        {enrollment?.hasCertificate
                            ? CertificateButton()
                            : enrollment?.canFinish
                                ? <EnrollmentCloseButton />
                                : isRecording
                                    ? RecordingButton()
                                    : !meeting.finished && meeting.meetingType != MeetingType.Presential && meeting.meetingOnlineLink
                                        ? JoinButton()
                                        : null
                        }
                    </>
            }
        </>
    );
};
